module.exports = __webpack_public_path__ + "static/media/wind-mill-green.40cdfd7c.svg";